import { z } from 'zod'

import { ApplicationError, type TeamMember } from '../domain'

export abstract class ForManagingTeamMembers {
	static AddTeamMember = z.object({
		teamId: z.string(),
		email: z.string().email(),
		role: z.string()
	})

	abstract addMember(
		params: z.infer<typeof ForManagingTeamMembers.AddTeamMember>
	): Promise<{
		data?: TeamMember
		error?: ApplicationError
	}>

	abstract removeMember(
		teamId: string,
		userId: string
	): Promise<{
		error?: ApplicationError
	}>

	abstract updateMemberRole(
		params: z.infer<typeof ForManagingTeamMembers.AddTeamMember>
	): Promise<{
		data?: TeamMember
		error?: ApplicationError
	}>

	abstract fetchMembers(teamId: string): Promise<{
		data?: TeamMember[]
		error?: ApplicationError
	}>
}
